export default __webpack_public_path__ + "images/41800869e55279ef84b2aacf20e58ec6-school.webp";